import { createEffect } from '../utils/create-effect';

export interface SelectionsPingEffectDeps {
  /**
   * Called on every selection change. Notifies the ping registry on the static
   * `database::selectionChanged` channel so that broadcast-level subscribers
   * (action bar, table layout, etc.) re-read aggregate state.
   */
  notifyDatabaseSelectionChanged: () => void;
}

/**
 * Used to notify coarse subscriptions to any selections changes.
 * This should be used sparingly as this acts as our bridge today
 * to communicate with some react components that are NOT widely used
 * in the way that table layout cells are.
 */
export const createSelectionsPingEffect = createEffect(
  ({ notifyDatabaseSelectionChanged }: SelectionsPingEffectDeps) => {
    return {
      deltaTypes: ['selectionReplaced', 'selectionModified'] as const,

      onDelta() {
        // Broadcast-level ping: always fires so aggregate-state consumers
        // (action bar, count badges, etc.) update on every selection change.
        notifyDatabaseSelectionChanged();
      },
    };
  }
);
